import dayjs from 'dayjs'

import 'dayjs/locale/pl'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/de'

const getCurrentLocale = () => {
  const pageLanguage = (document.documentElement.lang || 'pl')
    .toLowerCase()
    .replace('_', '-')

  switch (true) {
    case pageLanguage.startsWith('en'):
      return 'en-gb'

    case pageLanguage.startsWith('de'):
      return 'de'

    default:
      return 'pl'
  }
}

const currentLocale = getCurrentLocale()

dayjs.locale(currentLocale)

export const today = dayjs()
export const secondDay = dayjs().add(2, 'day')

const dateRangeStart = document.querySelector('#dateRangeStart')
const dateRangeEnd = document.querySelector('#dateRangeEnd')

const formatDate = (date, format) => {
  return dayjs(date).locale(currentLocale).format(format)
}

const formatMonth = (date) => {
  return formatDate(date, 'MMM').replace(/\.$/, '')
}

export const setBseWidgetDate = (firstDate = today, secondDate = secondDay) => {
  if (!dateRangeStart || !dateRangeEnd) {
    return
  }

  const startFullDate = dateRangeStart.querySelector('.date-full')
  const endFullDate = dateRangeEnd.querySelector('.date-full')

  if (startFullDate) {
    startFullDate.textContent = formatDate(firstDate, 'DD.MM.YYYY')
  } else {
    const startDay = dateRangeStart.querySelector('.date-day')
    const startMonth = dateRangeStart.querySelector('.date-month')
    const startYear = dateRangeStart.querySelector('.date-year')

    if (startDay) {
      startDay.textContent = formatDate(firstDate, 'DD')
    }

    if (startMonth) {
      startMonth.textContent = formatMonth(firstDate)
    }

    if (startYear) {
      startYear.textContent = formatDate(firstDate, 'YYYY')
    }
  }

  if (endFullDate) {
    endFullDate.textContent = formatDate(secondDate, 'DD.MM.YYYY')
  } else {
    const endDay = dateRangeEnd.querySelector('.date-day')
    const endMonth = dateRangeEnd.querySelector('.date-month')
    const endYear = dateRangeEnd.querySelector('.date-year')

    if (endDay) {
      endDay.textContent = formatDate(secondDate, 'DD')
    }

    if (endMonth) {
      endMonth.textContent = formatMonth(secondDate)
    }

    if (endYear) {
      endYear.textContent = formatDate(secondDate, 'YYYY')
    }
  }
}
